import React from 'react';
import Table from 'react-bootstrap/Table'
import { Licitacion } from '../models/Licitacion';
import ComponentLicitacionList from './ComponentLicatacionList'
import './ComponentLicitacionTable.scss'
interface PropsLicitacion{
  licitaciones:Licitacion[],
  setlicitacionForm: (licitacion : Licitacion) =>void
}

const ComponentLicitacionTable: React.FC<PropsLicitacion> = (props) =>{
    const trs_table = []
        
    const setlicitacionForm=(lic : Licitacion)=>{
        props.setlicitacionForm(lic)
    }
    
    if (props.licitaciones){
        for (let j = 0; j < (props.licitaciones).length; j++)
        {
            let licitacion = props.licitaciones[j];
            if (licitacion){
              trs_table.push(<ComponentLicitacionList setLicitacionForm={setlicitacionForm} licitacion={licitacion}></ComponentLicitacionList>)
            }
        }
    }
    return(
            <Table className="table-principal" bordered hover size="sm">
              <thead>
                <tr>
                  <th>Nº LICITACIÓN</th>
                  
                  <th>TIPO</th>
                  <th>OBJETO DE LA LICITACIÓN</th>
                  <th>VER</th>
                </tr>
              </thead>
              <tbody>
                {trs_table}
              </tbody>
            </Table>
    )
} 

export default ComponentLicitacionTable